import Input from './Input'

/** A basic textarea for longer text input. Takes the same props as `Input`. */
const TextArea = (props) => (
  <Input {...props} rows={props.rows || 4} multiline />
)

export default TextArea
